import { useState, useEffect } from "react";
import {
  TextField,
  Box,
  Button,
  CardMedia,
  Card,
  Typography,
  Avatar,
  Menu,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseLandingHeader } from "./UseLandingHeader";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import { SketchPicker } from "react-color";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function LandingHeaderManage() {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const navigate = useNavigate();
  const { isSmall } = useBreakpoints();
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { GetHeader, SetHeader } = UseLandingHeader();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [state, setState] = useState({
    id: undefined,
    showUser: false,
    backgroundColor: "",
    urL1: "/",
    urL2: "/",
    urL3: "/",
  });

  const [imgState, setImgState] = useState({
    imageFile1: undefined,
    imageUrl1: undefined,
    imageFile2: undefined,
    imageUrl2: undefined,
    imageFile3: undefined,
    imageUrl3: undefined,
  });

  const handleChangeImage1 = (file) => {
    setImgState({
      ...imgState,
      imageFile1: file[0],
      imageUrl1: URL.createObjectURL(file[0]),
    });
  };

  const handleChangeImage2 = (file) => {
    setImgState({
      ...imgState,
      imageFile2: file[0],
      imageUrl2: URL.createObjectURL(file[0]),
    });
  };

  const handleChangeImage3 = (file) => {
    setImgState({
      ...imgState,
      imageFile3: file[0],
      imageUrl3: URL.createObjectURL(file[0]),
    });
  };

  useEffect(() => {
    if (location.state.id) {
      setProgress(true);
      GetHeader(
        location.state.id,
        (header) => {
          setImgState({
            ...imgState,
            imageUrl1: header.logo1 ? header.logo1 : "",
            imageUrl2: header.logo2 ? header.logo2 : "",
            imageUrl3: header.logo3 ? header.logo3 : "",
          });
          setState({
            id: header.id !== 0 ? header.id : location.state.id,
            urL1: header.urL1 ? header.urL1 : "",
            urL2: header.urL2 ? header.urL2 : "",
            urL3: header.urL3 ? header.urL3 : "",
            showUser: header.showUser ? header.showUser : false,
            backgroundColor: header.backgroundColor
              ? header.backgroundColor
              : "",
          });
        },
        true
      );
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/landingmanagment/landingComponents",
        title: "مدیریت محتوا",
        backURL: "/landingmanagment",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/landingmanagment" },
          {
            name: "مدیریت هدر",
            url: "/landingmanagment/headerManage",
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 3 }}
          gridColumn="span 12"
        >
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage1(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "120px", height: "auto" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                    bgcolor: "#e0e0e0",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.imageUrl1
                        ? imgState.imageUrl1
                        : "/static/img/no-photos.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
          <TextField
            // fullWidth
            sx={{
              width: "50%",
              textarea: { direction: "rtl" },
            }}
            multiline
            maxRows={4}
            value={state.urL1 ? state.urL1 : ""}
            // error={errorState.urL1}
            label="لینک تصویر"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, urL1: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 3 }}
          gridColumn="span 12"
        >
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage2(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "120px", height: "auto" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                    bgcolor: "#e0e0e0",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.imageUrl2
                        ? imgState.imageUrl2
                        : "/static/img/no-photos.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
          <TextField
            // fullWidth
            sx={{
              width: "50%",
              textarea: { direction: "rtl" },
            }}
            multiline
            maxRows={4}
            value={state.urL2 ? state.urL2 : ""}
            // error={errorState.urL1}
            label="لینک تصویر"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, urL2: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 3 }}
          gridColumn="span 12"
        >
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage3(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "120px", height: "auto" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                    bgcolor: "#e0e0e0",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.imageUrl3
                        ? imgState.imageUrl3
                        : "/static/img/no-photos.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
          <TextField
            // fullWidth
            sx={{
              width: "50%",
              textarea: { direction: "rtl" },
            }}
            multiline
            maxRows={4}
            value={state.urL3 ? state.urL3 : ""}
            // error={errorState.urL3}
            label="لینک تصویر"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, urL3: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box gridColumn={isSmall ? "span 12" : "span  3"}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography color="secondary" variant="body1">
              رنگ پس زمینه:
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #D7D7D7",
                borderRadius: 2,
                p: 1,
                ml: 2,
              }}
            >
              <Avatar
                sx={{
                  bgcolor: state.backgroundColor,
                  boxShadow: 3,
                  width: 75,
                  height: 30,
                  mx: 1,
                  borderRadius: 1,
                }}
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                {" "}
              </Avatar>
              <Typography variant="body1">
                {state.backgroundColor ? state.backgroundColor : ""}
              </Typography>
            </Box>
            {state.backgroundColor ? (
              <Button
                sx={{ ml: 2 }}
                variant="outlined"
                onClick={(color) => {
                  setState({ ...state, backgroundColor: "" });
                }}
              >
                حذف
              </Button>
            ) : (
              ""
            )}
          </Box>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            sx={{
              "& .muirtl-6hp17o-MuiList-root-MuiMenu-list": {
                py: 0,
              },
            }}
          >
            <SketchPicker
              sx={{ position: "relative", top: "-130px" }}
              color={state.backgroundColor ? state.backgroundColor : ""}
              onChangeComplete={(color) => {
                setState({ ...state, backgroundColor: color.hex });
              }}
            />
          </Menu>
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn="span 12">
          <FormControlLabel
            checked={state.showUser}
            onChange={(evt) => {
              setState({ ...state, showUser: evt.target.checked });
            }}
            control={<Checkbox />}
            label="نمایش سبد خرید و دکمه ورود/ثبت نام"
          />
        </Box>
        <Box
          gridColumn="span 12"
          sx={{ my: 2, display: "flex", justifyContent: "center" }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => {
              //   if (validateItem(state, setErrorState) == 200) {
              setProgress(true);
              SetHeader(
                state,
                imgState.imageFile1,
                imgState.imageFile2,
                imgState.imageFile3,
                (calback) => {
                  navigate("/landingmanagment/landingComponents", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                }
              );
              //   }
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/landingmanagment/landingComponents", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
